import { useGetList } from "ra-core";

import type { Contact } from "../types";
import { DashboardActivityLog } from "./DashboardActivityLog";
import { DashboardStepper } from "./DashboardStepper";
import { FaroPanel } from "./FaroPanel";
import { TasksList } from "./TasksList";

export const Dashboard = () => {
  const { total: totalContact, isPending: isPendingContact } =
    useGetList<Contact>("contacts", {
      pagination: { page: 1, perPage: 1 },
    });

  if (isPendingContact) {
    return null;
  }

  // Onboarding: ainda sem qualquer contato → mantém o stepper inicial.
  if (!totalContact) {
    return <DashboardStepper step={1} />;
  }

  return (
    <div className="flex flex-col gap-6">
      <FaroPanel />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-2">
        <div className="md:col-span-2">
          <DashboardActivityLog />
        </div>
        <div className="md:col-span-1">
          <TasksList />
        </div>
      </div>
    </div>
  );
};
